import { Cache } from '@phensley/cldr-utils';
import { pluralRules } from '@phensley/plurals';
import { buildMessageMatcher, parseMessagePattern } from './parser';
import { MessageEngine } from './evaluation';
import { DefaultMessageArgConverter } from './evaluation/converter';
var DEFAULT_CACHE_SIZE = 100;
/**
 * Convenience class that caches parsed messages.
 *
 * @public
 */
var MessageFormatter = /** @class */ (function () {
    function MessageFormatter(options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.formatters = options.formatters || {};
        this.converter = options.converter || new DefaultMessageArgConverter();
        this.plurals = options.plurals || pluralRules.get(options.language || 'root', options.region);
        var size = options.cacheSize || DEFAULT_CACHE_SIZE;
        this.matcher = buildMessageMatcher(Object.keys(this.formatters));
        this.cache = new Cache(function (s) { return parseMessagePattern(s, _this.matcher); }, size);
    }
    /**
     * Parse and evaluate the message against the given argument. Internally caches parsed
     * messages for reuse.
     */
    MessageFormatter.prototype.format = function (message, positional, named) {
        var code = this.cache.get(message);
        return new MessageEngine(this.plurals, this.converter, this.formatters, code).evaluate(positional, named);
    };
    /**
     * String representation of this formatter.
     */
    MessageFormatter.prototype.toString = function () {
        return "MessageFormatter(formatters=" + JSON.stringify(Object.keys(this.formatters)) + " cached=" + this.cache.size() + ")";
    };
    return MessageFormatter;
}());
export { MessageFormatter };
//# sourceMappingURL=formatter.js.map